
/* DEWD quiz engine — answer capture, email handoff, profile results.
   The email step is a real Liquid {% form 'customer' %} section in the quiz
   template (so Shopify's CAPTCHA machinery signs it); this file just captures
   answers, fills the form's hidden fields, and routes the finish. */

var dewdQuiz = { answers: [] };
try { localStorage.removeItem('dewd_quiz'); } catch (e) {}

function dewd_classify(answers) {
  var d = { profile: '', age: '', fix: '', routine: '', speed: '' };
  answers.forEach(function (raw) {
    var t = raw.replace(/\s+/g, ' ').trim();
    if (/^(under 25|25.34|35.44|45.54|55.64|65\+)$/i.test(t)) { d.age = t; return; }
    if (/shiny|oily skin/i.test(t)) { d.fix = 'Oily by midday'; d.profile = 'oil-control'; return; }
    if (/dry or tight/i.test(t)) { d.fix = 'Dry after washing'; d.profile = 'dry-tight'; return; }
    if (/breakout|clogged|acne/i.test(t)) { d.fix = 'Breakouts'; d.profile = 'breakout'; return; }
    if (/sensitive or irritated/i.test(t)) { d.fix = 'Sensitive skin'; d.profile = 'sensitive'; return; }
    if (/don.t have one|whatever.s in|wash \+ hydrate|tried loads/i.test(t)) { d.routine = t; return; }
    if (/same day|within a week|few weeks|long.term/i.test(t)) { d.speed = t; return; }
  });
  return d;
}

function dewd_save() {
  var d = dewd_classify(dewdQuiz.answers);
  d.raw = dewdQuiz.answers;
  try { localStorage.setItem('dewd_quiz', JSON.stringify(d)); } catch (e) {}
  return d;
}

function dewd_results_url() {
  var d = dewd_save();
  var url = '/products/face-system?view=face_system_quiz';
  if (d.profile) url += '&profile=' + encodeURIComponent(d.profile);
  return url + '#MainContent';
}

function dewd_finish() {
  window.location.href = dewd_results_url();
}

/* Keep the email form's hidden fields in sync with the latest answers. */
function dewd_sync_form() {
  var d = dewd_save();
  var tags = ['quiz'];
  if (d.profile) tags.push('profile:' + d.profile);
  if (d.age) tags.push('age:' + d.age.toLowerCase().replace(/\s+/g, ''));
  $('.dewd-tags').val(tags.join(','));
  $('.dewd-return').val(dewd_results_url());
}

$(document).on('click', '.dewd-skip', function (e) {
  e.preventDefault();
  dewd_finish();
});

$(document).on('submit', '.dewd-email-form', function () {
  dewd_sync_form();
  try { if (typeof fbq === 'function') fbq('track', 'Lead'); } catch (err) {}
  /* no preventDefault — the native POST carries Shopify's CAPTCHA token */
});

$(document).on("click", 'a[href="#"]', function (e) {
  e.preventDefault();
  next_step();
});
$(document).on("click", '.QZ_section2_list1 .icons_with_text_flex .icons_with_text_item, .QZ_section_box .icons_with_text_flex .icons_with_text_item', function (e) {
  e.preventDefault();
  $(this).addClass('active');
  var txt = $(this).text().replace(/\s+/g, ' ').trim();
  if (txt && dewdQuiz.answers[dewdQuiz.answers.length - 1] !== txt) dewdQuiz.answers.push(txt);
  dewd_save();
  next_step();
});

$(document).on("click", '.quiz_header_svg', function (e) {
  e.preventDefault();
  prev_step();
});

$(document).on("click", 'a[href="#reviews"]', function (e) {
  e.preventDefault();
});

function next_step() {
  var loader = $('main#MainContent');
  var current_slide = $('.quiz_step.active').closest('.shopify-section');
  var next_slide = current_slide.next('.shopify-section');

  loader.addClass('loading_hk');

  if (!next_slide.length) {
    setTimeout(dewd_finish, 800);
    return;
  }

  setTimeout(function () {
    loader.removeClass('loading_hk');
    current_slide.find('.quiz_step').removeClass('active');
    next_slide.find('.quiz_step').addClass('active');
    if (next_slide.find('.dewd-email-form').length) dewd_sync_form();
    window.scrollTo(0, 0);
  }, 700);
}

function prev_step() {
  var loader = $('main#MainContent');
  var current_slide = $('.quiz_step.active').closest('.shopify-section');
  var next_slide = current_slide.prev('.shopify-section');

  loader.addClass('loading_hk');
  setTimeout(function () {
    loader.removeClass('loading_hk');
    current_slide.find('.quiz_step').removeClass('active');
    next_slide.find('.quiz_step').addClass('active');
  }, 300);
}
